
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DsEditor from "@/components/ds-editor/ds-editor.vue";
@Component({
  components: {
    DsEditor,
  },
})
export default class Name extends Vue {
  @Prop()
  private ifEdit: any;
  @Prop()
  private detail: any;
  @Watch("detail", { immediate: true })
  private detailChange() {
    // 处理数据
    let d: any = JSON.parse(JSON.stringify(this.detail));
    this.data = d;
  }
  private data: any = {};
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private mounted() { }
}
